var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXRay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 44,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    x: 0.667,
    fill: "url(#x-ray_svg__a)",
    rx: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.666 17c-2.756 0-5 2.243-5 5s2.244 5 5 5c.88 0 1.744-.231 2.501-.67l-.626-1.081A3.754 3.754 0 0118.916 22a3.754 3.754 0 013.75-3.75 3.754 3.754 0 013.75 3.75v.544c0 .41-.262.706-.625.706a.626.626 0 01-.625-.625v-2.5h-.864a2.479 2.479 0 00-1.636-.625 2.503 2.503 0 00-2.5 2.5c0 1.378 1.122 2.5 2.5 2.5.657 0 1.25-.26 1.697-.675.344.41.853.675 1.428.675 1.052 0 1.875-.859 1.875-1.956V22c0-2.757-2.242-5-5-5zm0 6.25a1.251 1.251 0 010-2.5 1.251 1.251 0 010 2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.6,
    d: "M32 15.167v2.75a.417.417 0 01-.417.416h-.833a.417.417 0 01-.417-.416v-2.75a.833.833 0 00-.833-.834h-2.75a.417.417 0 01-.417-.416v-.834a.417.417 0 01.417-.416h2.75a2.5 2.5 0 012.5 2.5zm-.417 10.5h-.833a.417.417 0 00-.417.416v2.75a.833.833 0 01-.833.834h-2.75a.417.417 0 00-.417.416v.834a.417.417 0 00.417.416h2.75a2.5 2.5 0 002.5-2.5v-2.75a.416.416 0 00-.417-.416zm-13 5.666a.417.417 0 00.417-.416v-.834a.416.416 0 00-.417-.416h-2.75a.833.833 0 01-.833-.834v-2.75a.416.416 0 00-.417-.416h-.833a.417.417 0 00-.417.416v2.75a2.5 2.5 0 002.5 2.5h2.75zm-5.25-16.166v2.75a.417.417 0 00.417.416h.833a.417.417 0 00.417-.416v-2.75a.833.833 0 01.833-.834h2.75a.417.417 0 00.417-.416v-.834a.416.416 0 00-.417-.416h-2.75a2.5 2.5 0 00-2.5 2.5z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "x-ray_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(41.45089 42.68297 -41.94536 40.73456 2.41 1.318)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD6CD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B3BBB"
  })))));
}

export default __webpack_public_path__ + "./fonts/x-ray.a784634efb9a7af16a453024c75943d8.svg";
export { SvgXRay as ReactComponent };